import { render, staticRenderFns } from "./OneView.vue?vue&type=template&id=e024f650"
import script from "./OneView.vue?vue&type=script&lang=js"
export * from "./OneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports